import { Editor } from '@tiptap/react';

import { TextLevelSelect } from './TextLevelSelect';

const textLevels: { value: string; label: string }[] = [
  { value: '1', label: 'title' },
  { value: '2', label: 'headline' },
  { value: '3', label: 'subHeadline' },
  { value: 'p', label: 'bodyText' }
];

export type TextLevelWithParagraphSelectProps = {
  editor: Editor | null;
};

export function TextLevelWithParagraphSelect(props: TextLevelWithParagraphSelectProps) {
  const { editor } = props;

  return <TextLevelSelect textLevels={textLevels} editor={editor} />;
}
